const DeleteStaffModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl w-96 text-center">
                <p className="mb-6">آیا از حذف این نیرو اطمینان دارید؟</p>

                <div className="flex justify-center gap-4">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border rounded-lg"
                    >
                        لغو
                    </button>

                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg"
                    >
                        بله، حذف کن
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteStaffModal;
